import axios from 'axios'

const isNewVersion = () => {
    let url = `//${window.location.host}/version.json?t=${new Date().getTime()}`
    axios.get(url).then(res => {
        if(res.status == 200) {
            let vueVersion = res.data.version
            let localVueVersion = localStorage.getItem('vueVersion')
            if(localVueVersion != vueVersion) {
                localStorage.setItem('vueVersion',vueVersion)
                setTimeout(() => {
                    window.location.reload()
                },100)
            }
        }
    })
}

export default {
    isNewVersion
}